export default __webpack_public_path__ + "static/media/cat8.12b5a22f.jpg";